<script setup>
import moment from "moment-timezone";
import { VDataTableServer } from "vuetify/labs/VDataTable";

moment.tz.setDefault("Asia/Jakarta");

const loading = ref();
const loadingTable = ref();
const loadingClear = ref();

definePage({
  meta: {
    layout: "default",
  },
});
const pageTitle = "Data Mall";

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "Master Data",
    to: null,
  },
  {
    title: pageTitle,
    to: null,
  },
];
const headers = [
  {
    title: "No",
    sortable: false,
    key: "id",
  },
  {
    title: "Mall Name",
    key: "name",
  },
  {
    title: "Address",
    key: "address",
  },
  {
    title: "Actions",
    sortable: false,
    key: "actions",
  },
];

const route = useRoute();
const router = useRouter();

const refForm = ref();

// Data table options
const itemsPerPage = ref(10);
const page = ref(1);
const orderBy = ref("createdAt");
const orderDirection = ref("ASC");

const search = ref(null);

const { data: dataQueries, execute: fetchQueries } = await useApi(
  createUrl("/cms/mall", {
    query: {
      limit: itemsPerPage,
      search: search,
      page,
      orderBy,
      orderDirection,
    },
  })
);

const updateOptions = async (options) => {
  loadingTable.value = true;
  page.value = options.page;
  orderBy.value = options.sortBy[0]?.key;
  orderDirection.value = options.sortBy[0]?.order;
  fetchQueries().then((value) => {
    loadingTable.value = false;
  });
};

const perPages = [5, 10, 25, 50];

const refreshResult = () => {
  loadingClear.value = true;
  loadingTable.value = true;
  search.value = null;
  fetchQueries().then((value) => {
    loadingClear.value = false;
    loadingTable.value = false;
  });
};

const searchResult = () => {
  loading.value = true;
  loadingTable.value = true;
  refForm.value?.validate().then(({ valid: isValid }) => {
    if (isValid) {
      fetchQueries().then((value) => {
        loading.value = false;
        loadingTable.value = false;
      });
    }
  });
};
const dataItems = computed(() => (dataQueries ? dataQueries.value?.data : []));
const totalItems = computed(() =>
  dataQueries ? dataQueries.value?.metadata.pagination.itemCount : []
);
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <h4 class="text-h4 my-4">{{ pageTitle }}</h4>
  <VCard>
    <VDataTableServer
      v-model:items-per-page="itemsPerPage"
      v-model:page="page"
      :headers="headers"
      :items="dataItems"
      :items-length="totalItems"
      :loading="loadingTable"
      class="text-no-wrap"
      @update:options="updateOptions"
    >
      <template #top>
        <div>
          <VRow class="ms-4 me-4 my-2">
            <VCol cols="12" lg="10" sm="10">
              <VForm
                ref="refForm"
                @submit.prevent="
                  () => {
                    searchResult();
                  }
                "
              >
                <div class="d-flex flex-rows gap-4">
                  <AppTextField
                    v-model="search"
                    clearable
                    placeholder="Input Mall Name"
                  />
                  <VBtn
                    :disabled="loading"
                    :loading="loading"
                    color="primary"
                    type="submit"
                  >
                    Search

                    <template #loader>
                      <span class="custom-loader">
                        <VIcon class="text-white" icon="tabler-refresh" />
                      </span>
                    </template>
                  </VBtn>
                  <VBtn
                    :disabled="loadingClear"
                    :loading="loadingClear"
                    color="secondary"
                    type="reset"
                    @click="refreshResult()"
                  >
                    <VIcon icon="tabler-refresh" start />
                    Clear
                  </VBtn>
                </div>
              </VForm>
            </VCol>
            <VCol cols="12" lg="2" sm="2">
              <AppSelect
                v-model="itemsPerPage"
                :items="perPages"
                class="ml-auto"
                placeholder="Per Page"
              />
            </VCol>

            <!--            <VCol cols="12" lg="2" sm="2">
                          <VBtn :to="{ path: 'mall/create' }" block color="primary">
                            <VIcon icon="tabler-plus" start />
                            Create {{ pageTitle }}
                          </VBtn>
                        </VCol>-->
          </VRow>
        </div>
      </template>
      <template #item.actions="{ item }">
        <div class="d-flex gap-1">
          <IconBtn :to="{ path: 'mall/update/' + item.id }">
            <VIcon icon="tabler-edit" />
          </IconBtn>
        </div>
      </template>
      <template #bottom>
        <VCardText class="pt-2">
          <div
            class="d-flex flex-wrap justify-center justify-sm-space-between gap-y-2 mt-2"
          >
            <div></div>
            <VPagination
              v-model="page"
              :length="Math.ceil(totalItems / itemsPerPage)"
              :total-visible="$vuetify.display.smAndDown ? 3 : 5"
            />
          </div>
        </VCardText>
      </template>
    </VDataTableServer>
  </VCard>
</template>
